import { Base } from "ui/Scripts/source/framework/base";
import { IRecordFamiliarizationListItem, RecordFamiliarizationListItem } from "ui/Scripts/source/models/recordFamiliarization/recordFamiliarizationListItem";

export interface IRecordCompanyRecordFamiliarizationListItems {
    companyId: string;
    companyName: string;
    familiarizations: IRecordFamiliarizationListItem[];
}

export class RecordCompanyRecordFamiliarizationListItems implements IRecordCompanyRecordFamiliarizationListItems {
    companyId: string;
    companyName: string;
    familiarizations: RecordFamiliarizationListItem[];

    constructor();
    constructor(obj: IRecordCompanyRecordFamiliarizationListItems);
    constructor(obj?: any) {
        this.companyId = obj && obj.companyId || "";
        this.companyName = obj && obj.companyName || "";
        this.familiarizations = Base.getTypedArray(obj?.familiarizations, RecordFamiliarizationListItem);
    }

    static equalIdsInFamiliarizations(a: IRecordCompanyRecordFamiliarizationListItems[], b: IRecordCompanyRecordFamiliarizationListItems[]): boolean {
        if (!a || !b) return false;
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            const aItem = a[i];
            const bItem = b.find(j => j.companyId === aItem.companyId);
            if (!bItem) return false;
            if (!Base.equalStrArrays(aItem.familiarizations.map(i => i.id), bItem.familiarizations.map(i => i.id))) return false;
        };
        return true;
    };
}